/******************************************************************************
Fertilizer Reducer: Handles all interactions & state changes with the fertilizer
component.
Hawaiian Macadamia Nut Services
Alexander Self
2/06/20
*******************************************************************************/
import moment from 'moment';
import { ADD_FERTILIZER, EDIT_FERTILIZER, SELECT_FERTILIZER_TO_EDIT, DELETE_FERTILIZER,
  SET_FERTILIZER_FORM, CREATE_FERTILIZER_APPLICATION, FETCH_FERTILIZER_APPLICATIONS,
  SELECT_FERTILIZER_APPLICATION, PREPARE_DATA, DELETE_FERTILIZER_APPLICATION, SELECT_FERT_APP_TO_EDIT,
  EDIT_FERTILIZER_APPLICATION, ERROR, CLEAR_FORM } from '../actions/types';
let initState = {
  fertilizerApplications: {
    all: [],
    displaying: []
  },
  view: {
    app: {}
  },
  app: {
    solidOrLiquid: 'S', // Determines if the form is for solids or liquids (tons applied vs. gal applied) Ganular vs Foliar spray
    type: CREATE_FERTILIZER_APPLICATION, // type of action
    path: 'createFertilizerApplication',
    editingApplication: false,
    fertilizerApplied: [], // Fertilizer records
    selectedFields: [],
    fertAppId: null, // Application ID if editing
    isEditing: false,
    editFertilizerApplied: {}, // Fertilizer being edited
    application: {}, // Application to submit
    previousApplications: [], // Previous applications within the same field, round
    deletedFertilizerApplied: [] // Fertilizers applied deleted during the app edit process(deletes serverside)
  }
};

export default function FertilizerReducer(state=initState, action) {
  switch (action.type) {
    case FETCH_FERTILIZER_APPLICATIONS:
      return { ...state,
        fertilizerApplications: {
          all: action.payload.sort(sortByDateField),
          displaying: action.payload.sort(sortByDateField)
        }
      }
    case CREATE_FERTILIZER_APPLICATION:
      return { ...state,
        fertilizerApplications: {
          all: state.fertilizerApplications.all.concat(action.payload).sort(sortByDateField),
          displaying: state.fertilizerApplications.all.concat(action.payload).sort(sortByDateField)
        },
        app: initState.app
      }
    case ADD_FERTILIZER:
      return { ...state,
        app: { ...state.app,
          fertilizerApplied: state.app.fertilizerApplied.concat(action.payload)
        }
      }
    case EDIT_FERTILIZER:
      return { ...state,
        app: { ...state.app,
          isEditing: false,
          editFertilizerApplied: initState.app.editFertilizerApplied,
          fertilizerApplied: state.app.fertilizerApplied.filter((f) => f.id !== state.app.editFertilizerApplied.id)
                                                        .concat({ id: state.app.editFertilizerApplied.id, ...action.payload }),
        }
      }
    case SELECT_FERTILIZER_TO_EDIT:
      return { ...state,
        app: { ...state.app,
          editFertilizerApplied: action.payload,
          solidOrLiquid: action.solOrLiq,
          isEditing: true
        }
      }
    case DELETE_FERTILIZER:
      return { ...state,
        app: { ...state.app,
          fertilizerApplied: state.app.fertilizerApplied.filter((f) => f.id !== action.payload.id),
          deletedFertilizerApplied: state.app.deletedFertilizerApplied.concat(action.payload.id)
        }
      }
    case SET_FERTILIZER_FORM:
      return { ...state,
        app: { ...state.app,
          solidOrLiquid: action.payload
        }
      }
    case PREPARE_DATA:
      return { ...state,
        app: { ...state.app,
          application: action.payload,
          previousApplications: action.previousApplications
        }
      }
    case SELECT_FERTILIZER_APPLICATION:
      return { ...state,
        view: {
          app: action.payload
        }
      }
    case DELETE_FERTILIZER_APPLICATION:
      return { ...state,
        fertilizerApplications: {
          all: state.fertilizerApplications.all.filter((f) => f.fertAppId !== action.payload).sort(sortByDateField),
          displaying: state.fertilizerApplications.displaying.filter((f) => f.fertAppId !== action.payload).sort(sortByDateField)
        },
        view: initState.view
      }
    case SELECT_FERT_APP_TO_EDIT:
      return { ...state,
        app: { ...state.app,
          type: EDIT_FERTILIZER_APPLICATION,
          path: 'editFertilizerApplication',
          editingApplication: true,
          fertAppId: action.payload.fertAppId,
          fertilizerApplied: action.payload.fertilizerApplied,
          deletedFertilizerApplied: initState.app.deletedFertilizerApplied,
          previousApplications: initState.app.previousApplications
        }
      }
    case EDIT_FERTILIZER_APPLICATION:
      return { ...state,
        fertilizerApplications: {
          all: state.fertilizerApplications.all.filter((f) => f.fertAppId !== action.payload.fertAppId).concat(action.payload).sort(sortByDateField),
          displaying: state.fertilizerApplications.all.filter((f) => f.fertAppId !== action.payload.fertAppId).concat(action.payload).sort(sortByDateField)
        },
        app: initState.app
      }
    case CLEAR_FORM:
      return { ...state,
        app: initState.app
      }
    case ERROR:
      return state;
    default:
      return state;
  }
}

function sortByDateField(a,b) {
  if ((moment(a.date).format('YYYY-MM-DD')) < (moment(b.date).format('YYYY-MM-DD'))) return 1;
  else if ((moment(a.date).format('YYYY-MM-DD')) > (moment(b.date).format('YYYY-MM-DD'))) return -1;
  else if ((moment(a.date).format('YYYY-MM-DD')) === (moment(b.date).format('YYYY-MM-DD'))) {
    if (a.field < b.field) return -1;
    else if (a.field > b.field) return 1;
    return 0;
  }
  return 0;
}






















/* END */



// WEBPACK FOOTER //
// ./src/cultivation/reducers/fertilizer_reducer.js